module.exports = __webpack_public_path__ + "img/SketchPng94ac18f79fb3f8e7cba704fbb52043c05df74695e2a85614ea3cbcc069539657.c27fcde4.png";